/**
 * The user's pose review (lane C0-POSE-FIX): what the user set in the studio's ท่าทาง (ทบทวน) tab, round by round,
 * kept in catalog.review.json beside the catalogue (written by the dev server's /__studio/pose-review endpoint,
 * vite.config.ts). The game reads approvals only from here: a new pose, idle, hold or polish is switched on in play
 * only once its status is `approved` (per id, not a global flag).
 */
import REVIEW from './catalog.review.json';

/** Where an item stands in the review. `review`: ready for the user's round; `rejected`: sent back with a comment. */
export type Status = 'old' | 'researching' | 'draft' | 'review' | 'approved' | 'rejected';
export type Verdict = 'pending' | 'keep' | 'adapt' | 'redo';

export interface Review {
  status?: Status;
  verdict?: Verdict;
  /** The user's comment (why rejected, what to change). */
  comment?: string;
  notes?: string;
  /** The review round the item was handed in for. */
  round?: number;
}

/** By item key (`<kind>:<id>`, e.g. `idle:mRooted`, `hold:revArm`, `pose:glide`). */
export const REVIEWS: Readonly<Record<string, Review>> = REVIEW as Record<string, Review>;

/** The item is approved by the user for the game. */
export const approved = (key: string): boolean => REVIEWS[key]?.status === 'approved';

export const STATUSES: readonly Status[] = ['old', 'researching', 'draft', 'review', 'approved', 'rejected'];
export const VERDICTS: readonly Verdict[] = ['pending', 'keep', 'adapt', 'redo'];
